import { Ramo } from './ramo';
import { Model } from './model';

export class GruppoRami extends Model {
    static apiUrl: string = "gruppi_rami";

    nome: string;
    descrizione: string;
    rami: Ramo[];

    deserialize(input: any): GruppoRami {
        let retV: GruppoRami = new GruppoRami();

        retV = super.deserialize(input) as GruppoRami;

        if (input?.rami) {
            retV.rami = input.rami.map(m => new Ramo().deserialize(m));
        }


        return retV;
    }

}
